import React, { useState, useEffect } from 'react';
import { getFaqHtml } from '../../../../services/Api';
import { MyDeliveriesFaqStyled } from './MyDeliveriesFaq.styled';
import Accordion from '../../../_common/accordion';
import Loader from "shared-anpost-components/components/loader/Loader";

const MyDeliveriesFaq = () => {
  const [data, setData] = useState();


  useEffect(() => {
    const fetchData = async () => {
      try {
         await getFaqHtml().then((res) => setData(JSON.parse(res.data.data.content[0].data[0].value)));
        
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <MyDeliveriesFaqStyled>
      {data ? <Accordion items={data.properties.faqs} /> : <Loader />}
       
    </MyDeliveriesFaqStyled> );
};

export default MyDeliveriesFaq;
